import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { RoleEnum } from '@/api/rest/resources/types/membership';
import { Industry } from '@/api/rest/resources/types/organization';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useUser } from '@/lib/auth';

import { FormCardField } from './form/FormCardField';
import { FORM_FIELD_NAMES } from './form/OnboardingForm';
import { SectionHeader } from './Section';

export const OnboadingIndustry = () => {
  const { t } = useTranslation();

  const user = useUser();
  const isAdmin = user.membership.role === RoleEnum.admin;
  const isStaff = useIsStaffUser();

  return (
    <Stack spacing={8}>
      <SectionHeader i18nPath='shared.onboarding.industry.description' />
      <Stack spacing={2}>
        {Object.values(Industry).map((industry) => (
          <FormCardField
            key={`industry-${industry}`}
            title={t(`shared.onboarding.industry.industry.${industry}.title`)}
            formField={FORM_FIELD_NAMES.INDUSTRY}
            formValue={industry}
            disabled={!isAdmin && !isStaff}
          />
        ))}
      </Stack>
    </Stack>
  );
};
